// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/badge/style/index.css
// module id = 819
// module chunks = 0